module.exports = __webpack_public_path__ + "static/media/dropdown.59456f5e.png";